import React, {type ComponentType} from 'react';

import {getSupplementTypeDefinition} from 'client/SupplementTypes/SupplementTypeDefinitions';

interface SupplementTypeRendererProps {
  /** Supplement type slug used to look up the type definition. */
  supplementType: string;
  [key: string]: unknown;
}

/**
 * Renders the 'renderer' component from a supplement type definition. The definitions registry is
 * built once at module evaluation (with SupplementNotFoundType as fallback), so the looked-up
 * renderer is a stable module-level component — but the React Compiler can't see through the
 * registry lookup, so callers resolving it during render get flagged for creating a component
 * during render. Centralize the lookup (and its justification) here instead.
 */
export function SupplementTypeRenderer({supplementType, ...rest}: SupplementTypeRendererProps) {
  // oxlint-disable-next-line react/react-compiler -- registry lookup returns a module-level component defined once at module evaluation, not created per render
  const Renderer: ComponentType<any> = getSupplementTypeDefinition(supplementType).get('renderer');
  // oxlint-disable-next-line react/react-compiler -- see above
  return <Renderer {...rest} />;
}
